"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _search = _interopRequireDefault(require("./assets/search.svg"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
const InputSearchWrapperStyled = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  position: relative;\n"])));
const InputSearchStyled = _styledComponents.default.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  height: 54px;\n  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 19px;\n  color: rgba(0, 0, 0, 0.87);\n  padding: 17px 12px 18px 44px;\n  box-sizing: border-box;\n  width: 100%;\n  outline: none;\n  border: none;\n  &::placeholder {\n    color: rgba(0, 0, 0, 0.87);\n  }\n"])));
const IconSearchStyled = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 15px;\n  top: calc(50% - 8.745px);\n  img{\n    width: 17.49px;\n    height: 17.49px;\n    color: rgba(0, 0, 0, 0.54);\n  }\n"])));
const Search = _ref => {
  let {
    bank,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(InputSearchWrapperStyled, {
    className: "search-control"
  }, /*#__PURE__*/_react.default.createElement(IconSearchStyled, {
    className: "icon-search"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _search.default,
    placeholder: _search.default
  })), /*#__PURE__*/_react.default.createElement(InputSearchStyled, _extends({
    type: "text"
  }, props)));
};
exports.Search = Search;
Search.propTypes = {};
Search.defaultProps = {};